var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704   c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704   C78.477,17.894,78.477,18.586,78.049,19.015z","fill":"#FFFFFF"})),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
}

CheckMark.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 78.369 78.369","style":{"enableBackground":"new 0 0 78.369 78.369"},"xmlSpace":"preserve"};

module.exports = CheckMark;

CheckMark.default = CheckMark;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/assets/check-mark.svg
// module id = 535
// module chunks = 0